import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useApiQuery } from '@/api/main/query'
import { useIsMobile } from '@/shared/utils'
import {
  exchangeRatesAPI,
  ExchangeRatesModel,
  fetchRatesSuccess,
  ProviderName,
  ProviderNameMobile,
  RateDisplay,
  RateDisplayMobile,
  selectProviderRatesInfo,
} from '@/entities/exchangeRates'
import { ActiveBar } from '@/shared/components'

export const ExchangeInfo = () => {
  const dispatch = useDispatch()
  const providerRates = useSelector(selectProviderRatesInfo)
  const [activeProviderIndex, setActiveProviderIndex] = useState(0)
  const [isActiveBar, setIsActiveBar] = useState(true)
  const isMobile = useIsMobile()

  const { data: exchangeData, refetch } = useApiQuery<ExchangeRatesModel[]>(
    ['exchange-rates'],
    exchangeRatesAPI.baseKey,
    undefined,
    {
      refetchInterval: 60000,
      refetchOnWindowFocus: false,
    }
  )

  useEffect(() => {
    if (exchangeData) {
      dispatch(fetchRatesSuccess(exchangeData))
    }
  }, [exchangeData, dispatch])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        refetch()
      }
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [refetch])

  useEffect(() => {
    if (providerRates.length < 2) return

    const interval = setInterval(() => {
      setIsActiveBar((prev) => !prev)
      setActiveProviderIndex((prev) => (prev === providerRates.length - 1 ? 0 : prev + 1))
    }, 3000)

    return () => clearInterval(interval)
  }, [providerRates.length])

  if (providerRates.length === 0) {
    return (
      <div className="flex flex-col flex-shrink-0 gap-y-4">
        <div className="text-text-secondary text-sm">Нет данных о курсах</div>
      </div>
    )
  }

  const currentProvider = providerRates[activeProviderIndex]

  return (
    <div className="flex flex-col flex-shrink-0 gap-y-4">
      {isMobile ? (
        <div className="px-4">
          <div className="flex justify-between items-center mb-4">
            <ProviderNameMobile
              providerName={currentProvider.name}
              lastUpdate={currentProvider.lastUpdated}
            />
            {providerRates.length > 1 && <ActiveBar isActiveBar={isActiveBar} />}
          </div>
          <RateDisplayMobile
            courseIn={currentProvider.payInRate}
            courseOut={currentProvider.payOutRate}
          />
        </div>
      ) : (
        <div className="px-4">
          <div className="flex flex-col items-start gap-y-1">
            {providerRates.length > 1 && <ActiveBar isActiveBar={isActiveBar} />}
            <ProviderName
              providerName={currentProvider.name}
              lastUpdate={currentProvider.lastUpdated}
            />
          </div>
          <RateDisplay
            courseIn={currentProvider.payInRate}
            courseOut={currentProvider.payOutRate}
            className="flex flex-col items-start gap-y-1"
          />
        </div>
      )}
    </div>
  )
}
